/* GRAVURZEILE – Wischhinweis
   Zeigt auf dem Smartphone, dass eine waagerechte Reihe weitergeht.

   Zwei Dinge, bewusst getrennt:
     weiche Kante  – immer, solange die Reihe ueberlaeuft
     Anstupsen     – einmal je Reihe, beim ersten Hereinscrollen

   Angestupst wird die Reihe selbst, nicht die Kacheln. Ein Zucken der
   Kacheln sieht nach Fehler aus und zeigt nicht, was man tun soll. Ein
   Stueck echte Bewegung nach rechts zeigt genau die Geste.

   .mf-reihe bekommt nur die Kante: dort stehen schon Pfeiltasten. */

(function () {
  'use strict';

  if (window.__mfWischhinweis) return;
  window.__mfWischhinweis = true;

  var ALLE  = '.mf-an__zeile, .mf-nh__bahn, .mf-nh__filter, .mf-reihe';
  var STUPS = '.mf-an__zeile, .mf-nh__bahn, .mf-nh__filter';

  function passt(el, auswahl) {
    var f = el.matches || el.msMatchesSelector || el.webkitMatchesSelector;
    return f ? f.call(el, auswahl) : false;
  }
  function frage(abfrage) {
    return !!(window.matchMedia && window.matchMedia(abfrage).matches);
  }
  function sparsam()  { return frage('(prefers-reduced-motion: reduce)'); }
  function mitFinger(){ return frage('(hover: none)'); }

  function kanten(el) {
    var rest   = el.scrollWidth - el.clientWidth;
    var offen  = rest > 4;
    var links  = offen && el.scrollLeft > 4;
    var rechts = offen && el.scrollLeft < rest - 4;
    el.classList.toggle('mf-wh--lr', links && rechts);
    el.classList.toggle('mf-wh--l',  links && !rechts);
    el.classList.toggle('mf-wh--r',  rechts && !links);
  }

  function anstupsen(el) {
    if (el.dataset.mfStups) return;
    el.dataset.mfStups = 'fertig';

    if (sparsam() || !mitFinger()) return;

    var rest = el.scrollWidth - el.clientWidth;
    if (rest < 24 || el.scrollLeft > 2) return;

    var weg = Math.min(44, Math.round(rest / 2));
    var abgebrochen = false;

    function aufraeumen() {
      el.removeEventListener('touchstart', abbrechen);
      el.removeEventListener('wheel', abbrechen);
      el.classList.remove('mf-wh--stups');
      kanten(el);
    }
    function abbrechen() {
      if (abgebrochen) return;
      abgebrochen = true;
      aufraeumen();
    }

    el.addEventListener('touchstart', abbrechen, { passive: true });
    el.addEventListener('wheel', abbrechen, { passive: true });
    el.classList.add('mf-wh--stups');

    try { el.scrollTo({ left: weg, behavior: 'smooth' }); }
    catch (e) { el.scrollLeft = weg; }

    setTimeout(function () {
      if (abgebrochen) return;
      try { el.scrollTo({ left: 0, behavior: 'smooth' }); }
      catch (e) { el.scrollLeft = 0; }
      setTimeout(function () { if (!abgebrochen) aufraeumen(); }, 520);
    }, 470);
  }

  function beobachten(el) {
    if (!('IntersectionObserver' in window)) { anstupsen(el); return; }
    var wache = new IntersectionObserver(function (eintraege) {
      for (var i = 0; i < eintraege.length; i++) {
        if (eintraege[i].isIntersecting) {
          wache.disconnect();
          setTimeout(function () { anstupsen(el); }, 280);
          return;
        }
      }
    }, { threshold: 0.5 });
    wache.observe(el);
  }

  function ausstatten(el) {
    if (el.dataset.mfWh === 'an') return;
    el.dataset.mfWh = 'an';

    var neu = function () { kanten(el); };
    el.addEventListener('scroll', neu, { passive: true });
    window.addEventListener('resize', neu);
    if (window.ResizeObserver) { new ResizeObserver(neu).observe(el); }

    neu();
    /* Produktbilder kommen spaeter, dann stimmt die Breite erst. */
    setTimeout(neu, 600);
    setTimeout(neu, 2500);

    if (passt(el, STUPS)) beobachten(el);
  }

  function start() {
    var reihen = document.querySelectorAll(ALLE);
    for (var i = 0; i < reihen.length; i++) ausstatten(reihen[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
}());
